import React from "react";
import MediaList from "../../MediaList";
import * as svg from '../../SvgAssets';


const sectionList = [
  {
    title: "Deploy Content",
    icon: svg.instant,
    content: <p>Send content to multiple display in a fast and reliable way.
      Lumio works on various network condition, including 3G network.
    </p>
  },
  {
    title: "Manage Content",
    icon: svg.online,
    content: <p>Upload and schedule your content from anywhere & anytime - from laptop, desktop or mobile web browser.
    </p>
  },
  {
    title: "Interactive Content",
    icon: svg.interactive,
    content: <p>Do not limit yourself with static and boring content.
      With our vast collections of library and apps, you can send interactive content to your display.
    </p>
  }
];


export default () =>
  <div className="row">
    <div className="col-md-6">
      <h2>Explore Limitless
        Possibilites & New Opportunities
        <hr/>
      </h2>
    </div>
    <div className="col-md-6">
      {sectionList.map((item, id) =>
        <MediaList
          key={id}
          icon={item.icon}
          title={item.title}>{item.content}
        </MediaList>)}
    </div>
  </div>



// WEBPACK FOOTER //
// ./src/components/Page/Home/Explore.js